var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{style:({ fill : _vm.$attrs.bgColor }),attrs:{"fill":"#448AFF","d":"M24,4C13.5,4,5,12.1,5,22c0,5.2,2.3,9.8,6,13.1V44l7.8-4.7c1.6,0.4,3.4,0.7,5.2,0.7c10.5,0,19-8.1,19-18C43,12.1,34.5,4,24,4z"}}),_c('path',{style:({ fill : _vm.$attrs.fgColor }),attrs:{"fill":"#FFF","d":"M12 28L22 17 27 22 36 17 26 28 21 23z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }